module.exports = __webpack_public_path__ + "static/media/custom.1f05a684.svg";